import React from 'react';
import '../styles/App.css';

class NavBar extends React.Component {

  render() {
    return(
      <div className="navbar navbar-expand-md navbar-light bg-light">
        <div style={{cursor: 'pointer', fontSize: '16pt', letterSpacing: '3px', color: '#201735'}} className="navbar-brand title">ANCORA</div>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-navigation">
            <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="main-navigation" style={{float: 'none', marginLeft: '-100px'}}>
            <ul className="navbar-nav mx-auto">
                <li className="nav-item nav-styling">
                    <div className="nav-link navbar-text">Dashboard</div>
                </li>
                <li className="nav-item nav-styling">
                    <div className="nav-link navbar-text">My health</div>
                </li>
                <li className="nav-item nav-styling">
                    <div className="nav-link navbar-text">My statistics</div>
                </li>
            </ul>
        </div>
    </div>
    )
  }
}
export default NavBar;
